// Custom components
import React, { useState } from "react";
import { countries } from "countries-list";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select, { components } from "react-select";
function InputField(props) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    onchange,
    onkeydown,
    required,
    countryCode, // Receive the countryCode prop
    onCountryCodeChange, // Receive the function to update countryCode
  } = props;

  // Get an array of country calling codes and labels
  const countryCallingCodes = Object.keys(countries).map((countryCode) => {
    const country = countries[countryCode];
    return {
      label: `+${country.phone}`,
      value: `+${country.phone}`,
      countryCode: countryCode.toLowerCase(),
    };
  });

  // const [countryCode, setCountryCode] = useState("");

  const CustomOption = ({ innerProps, label, data }) => (
    <div
      {...innerProps}
      className="z-10 m-2 flex cursor-pointer text-sm font-medium"
    >
      <span>
        <img
          className="w-5"
          src={`https://flagcdn.com/${data.countryCode}.svg`} // Replace with the actual flag URL
          alt={data.label}
          style={{ marginRight: "8px" }}
        />
      </span>
      {label}
    </div>
  );

  const CustomSingleValue = ({ children, data, ...props }) => (
    <components.SingleValue {...props} className="flex">
      <img
        className="w-5"
        src={`https://flagcdn.com/${data.countryCode}.svg`}
        alt={data.label}
        style={{ marginRight: "8px" }}
      />
      {children}
    </components.SingleValue>
  );

  const handleSelectChange = (selectedOption) => {
    // Pass the selected value to the onchange function
    onCountryCodeChange(selectedOption.value);
  };

  const [phoneValue, setPhoneValue] = useState(""); // State to manage phone input value

  const handlePhoneInputChange = (value, data) => {
    // Update phoneValue state when phone number changes
    setPhoneValue(value);

    // Pass the selected phone number value to the onCountryCodeChange function
    onCountryCodeChange(value);
  };

  // console.log(countryCode);
  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
        <span className="text-sm text-red-500">{required}</span>
      </label>
      {type === "tel" ? (
        <ReactPhoneInput
          country={"in"}
          placeholder={placeholder}
          onChange={handlePhoneInputChange}
          buttonClass={`!rounded-tl-xl !rounded-bl-xl hover:!bg-white !bg-white !border !border-gray-200 ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
              ? "!border-red-500 !text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "!border-gray-200 dark:!border-white/10 dark:!text-white"
          }`}
          inputClass={`!mt-1 flex !h-12 !w-full !items-center !justify-center !rounded-xl !border !bg-white/0 !p-3 !pl-[48px] !text-sm !outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
              ? "!border-red-500 !text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "!border-gray-200 dark:!border-white/10 dark:!text-white"
          }`}
        />
      ) : (
        <input
          disabled={disabled}
          type={type}
          id={id}
          placeholder={placeholder}
          onChange={onchange}
          onKeyUp={onkeydown}
          className={`mt-1 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
              ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "border-gray-200 dark:!border-white/10 dark:text-white"
          }`}
        />
      )}
    </div>
  );
}

export default InputField;
